<template>
  <b-form-input
    :value="value"
    v-bind="$attrs"
    v-on="forwardedListeners"
    @input="onInput"
    @change="onChange"
  />
</template>

<script>
function toLowercaseEmail(value) {
  return String(value ?? '').trim().toLowerCase();
}

export default {
  name: 'EmailInput',
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  computed: {
    forwardedListeners() {
      const listeners = { ...this.$listeners };
      delete listeners.input;
      delete listeners.change;
      return listeners;
    },
  },
  methods: {
    onInput(val) {
      this.$emit('input', toLowercaseEmail(val));
    },
    onChange(val) {
      this.$emit('change', toLowercaseEmail(val));
    },
  },
};
</script>
